/*
Уровень сообщения о выходе за граничные значения
*/

export enum PMBoundaryMessageLevel {
  //Информирование
  Info = 1,

  //Предупреждение
  Warning = 2,

  //Угроза
  Alert = 3,
}

/*
Системный статус программного модуля (на основе статуса systemd)
*/

export enum PMProcessStatus {
  Active = 1,

  Inactive = 2,

  Failed = 3,

  Other = 4,
}

export function convertProcessStatus(processStatus: string): PMProcessStatus {
  switch (processStatus) {
    case 'active':
      return PMProcessStatus.Active;
    case 'inactive':
      return PMProcessStatus.Inactive;
    default:
      return PMProcessStatus.Inactive;
  }
}

/*
Тип команды для PM Manager
*/
export enum PMProcessActionType {
  Start = 'start',
  Stop = 'stop',
  Restart = 'restart',
}

/*
Тип окна
*/
export enum PMWindowType {
  //Окно Хэннинга
  Hanning = 1,

  //Окно Хэмминга
  Hamming = 2,

  //Окно Блекмена
  Blackman = 3,

  //Квадратное окно
  Squared = 4,
}

/*
Тип action ПМ
*/
export enum PMActionType {
  StartRecord = 'start_record',
  GetCalibrationTable = 'get_calibration_table',
  GetFullSpectrum = 'get_full_spectrum',
  GetRawSignal = 'get_raw_signal',
  GetActiveDevices = 'get_active_devices',
}

/*
Тип системной команды для PM
*/
export enum PMProcessSystemType {
  EmitLastSystemctlStatus = 'emit_last_systemctl_status',
}

/*
Типы событий ПМ (нам нужно пока только одно: выход за границу)
*/
export enum PMEventType {
  BoundaryPassed = 'boundary_passed',
}
